import { Controller } from '@hotwired/stimulus'
import { StreamEvent, StreamEventDetail } from './stream-manager'

export default class ActivitiesPanelController extends Controller {
  connect() {
    // FIXME: 'activities' might be more appropriate, but requires some BE rewiring
    document.addEventListener('stream-manager:render-activity', this.#handleStream)
  }

  disconnect() {
    document.removeEventListener('stream-manager:render-activity', this.#handleStream)
  }

  #handleStream = (event: StreamEvent) => {
    const { streamElement } = event.detail
    // Switch stucture left on purpose to always name the actions being handled
    switch (streamElement.action) {
      case 'append':
        this.#appendAction(event.detail)
        break
      default:
      // No default by design
    }

    window.app.tooltipManager.init()
    window.app.tooltipManager.resetTooltip()
  }

  #appendAction({ originalRender, streamElement }: StreamEventDetail) {
    const newMessageAlert = this.element.querySelector<HTMLElement>('#new-message-alert')!
    const noteContainer = this.element.querySelector('#submission-activity-list')

    if (!noteContainer) return

    originalRender(streamElement)

    this.#watchForNewActivities()
    this.#newMessageText()
    this.#handleMessageClick(newMessageAlert)
  }

  #watchForNewActivities() {
    const activities = Array.from(this.element.querySelectorAll('.broadcasted'))
    const newMessageAlert = this.element.querySelector('#new-message-alert')!
    const options = {
      root: this.element,
      threshold: 0.1,
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const activitiesNotification = this.element.querySelector('.activities-notification')!
        const activitiesCount = activitiesNotification.querySelector('.activities-count')!
        const messageContent = entry.target.querySelector('.message-content')!
        const messageCountText = this.element.querySelector('.btn-count')!
        const newMessageCount = activities.length
        const container = entry.target.closest('li')!

        if (entry.isIntersecting) {
          container.classList.remove('broadcasted')
          messageContent.classList.add('transition', 'duration-500', 'ease-in')
          messageContent.classList.remove('bg-whitelabel-100')

          const updatedActivities = Array.from(this.element.querySelectorAll('.broadcasted'))

          activitiesCount.innerHTML = `${updatedActivities.length.toString()}`
          updatedActivities.length < 2
            ? (messageCountText.innerHTML = `${updatedActivities.length.toString()} New Message`)
            : (messageCountText.innerHTML = `${updatedActivities.length.toString()} New Messages`)

          if (updatedActivities.length < 1) {
            newMessageAlert.classList.add('hidden')
            activitiesNotification.classList.add('hidden')
          }

          observer.unobserve(entry.target)
        } else {
          newMessageAlert.classList.remove('hidden')
          activitiesNotification.classList.remove('hidden')
          activitiesCount.innerHTML = `${newMessageCount}`
          newMessageCount < 2
            ? (messageCountText.innerHTML = `${newMessageCount} New Message`)
            : (messageCountText.innerHTML = `${newMessageCount} New Messages`)
        }
      })
    }, options)

    return activities.forEach(activity => {
      observer.observe(activity)
    })
  }

  #newMessageText() {
    const newMessages = this.element.querySelectorAll('.broadcasted').length
    const messageCount = this.element.querySelector('.message-count')
    const activitiesNotification = this.element.querySelector('.activities-notification')

    if (!activitiesNotification) {
      return
    }

    const activitiesCount = activitiesNotification.querySelector('.activities-count')!

    if (!messageCount || !newMessages) {
      return
    }

    activitiesNotification.classList.remove('hidden')
    activitiesCount.innerHTML = `${newMessages}`

    newMessages < 2
      ? (messageCount.innerHTML = `${newMessages} New Message`)
      : (messageCount.innerHTML = `${newMessages} New Messages`)
  }

  #handleMessageClick(message: HTMLElement) {
    if (!message) return

    message.addEventListener('click', () => {
      const broadcastedArr = Array.from(document.querySelectorAll('.broadcasted'))

      broadcastedArr[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }
}
